export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/draw.worker.c88956039d4a42cda58b.worker.js");
}
